var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"depressed":"","color":"primary","fab":"","small":"","outlined":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-pencil-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }